<template>
  <div class="card bm-4">
          <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">პერსონალური დეტალები</span>
                        </h5>
                      </div>
          <div class="car-body">
            <div>
          <!-- <div class="row">
            <div class="col-xl-12">
              <div class="card -20">
                <div class="col-lg-4 g-mb-40 g-mb-0--lg"></div>
              </div>
            </div>
          </div>-->

          <div class="row" id="print">
            <div class="col-xl-12">
              <div class="g-brd-around g-brd-gray-light-v4 g-pa-20 g-mb-40">
                <div class="row">
                  <div class="col-lg-4 g-mb-40 g-mb-0--lg">
                    <!-- User Image -->
                    <div class="g-mb-20 text-center">
                      <img
                        class="img-fluid w-100"
                        :src="personDetails.imageURL?personDetails.imageURL: ''"
                        alt=" სურათი არ არსებობს"
                      />
                    </div>
                    <!-- User Image -->

                    <!-- User Contact Buttons -->
                    <!-- <a
                      class="btn btn-block btn-outline-primary g-rounded-50 g-py-12 g-mb-10"
                      href="#"
                    >
                      <i class="icon-user-follow g-pos-rel g-top-1 g-mr-5"></i> Follow Me
                    </a>
                    <a
                      class="btn btn-block btn-outline-secondary g-rounded-50 g-py-12 g-mb-10"
                      href="#"
                    >
                      <i class="icon-call-in g-pos-rel g-top-1 g-mr-5"></i> Contact Me
                    </a>-->
                    <!-- End User Contact Buttons -->
                  </div>
                  <div class="col-lg-8">
                    <!-- User Details -->
                    <div class="d-flex align-items-center justify-content-sm-between g-mb-5">
                      <h2
                        class="g-font-weight-300 g-mr-10"
                      >{{personDetails.forename}} {{personDetails.middlename}} {{personDetails.surname}}</h2>
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item g-mx-2">
                          <button
                            @click="personDetails = {}, showPersonalDetails = false"
                            class="btn mr-1 mb-1 btn-outline-danger"
                          >
                            <i class="mr-2 fas fa-angle-double-left"></i>
                            <span class="e-mtavr-17">დახურვა</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <!-- End User Details -->

                    <!-- დამთხვევის პროცენტი დასაწყისი-->
                    <h4 class="h6 g-font-weight-300 g-mb-10" v-if="personDetails.score">
                      <i class="fas fa-info-circle g-pos-rel g-top-1 g-mr-5 g-color-gray-dark-v5"></i>
                      <span class="e-nusx-8">
                        <small>დამთხვევის პროცენტი:</small>
                      </span>
                      <strong>{{personDetails.score }} %</strong> &nbsp;
                    </h4>
                    <!-- დამთხვევის პროცენტი დასასრული-->
                    <!-- დაბადების და გარდაცვალების თარიღების დასაწყისი -->
                    <h4 class="h6 g-font-weight-300 g-mb-10">
                      <i class="far fa-calendar-alt g-pos-rel g-top-1 g-mr-5 g-color-gray-dark-v5" v-if="personDetails.dateOfBirth || personDetails.yearOfBirth"></i>
                      <span class="e-nusx-8" v-if="personDetails.dateOfBirth || personDetails.yearOfBirth">
                        <small>დაბადების თარიღი:</small>
                      </span>
                      <strong v-if="personDetails.dateOfBirth || personDetails.yearOfBirth">{{personDetails.dateOfBirth ? personDetails.dateOfBirth : personDetails.yearOfBirth }}&nbsp;</strong>
                      <i class="far fa-calendar-alt g-pos-rel g-top-1 g-mr-5 g-color-gray-dark-v5" v-if="personDetails.dateOfDeath || personDetails.yearOfDeath"></i>
                      <span class="e-nusx-8" v-if="personDetails.dateOfDeath || personDetails.yearOfDeath">
                        <small>გარდაცვალების თარიღი:</small>
                      </span>
                      <strong v-if="personDetails.dateOfDeath || personDetails.yearOfDeath">{{personDetails.dateOfDeath ? personDetails.dateOfDeath : personDetails.yearOfDeath }}</strong>
                    </h4>
                    <!-- დაბადების და გარდაცვალების თარიღების დასასრული -->

                    <!-- User Info -->
                    <ul class="list-inline g-font-weight-300">
                      <li class="list-inline-item g-mr-20 g-mb-10" v-if="personDetails.nationality.nationality && investigatingRequest.juridicalStatusId === 1">
                        <i class="fas fa-map-marker g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                        <span class="e-nusx-8">
                          <small>მოქალაქეობა:</small>
                        </span>
                        <span v-for="na in personDetails.nationality" :key="na.nationality">
                          <strong>{{na}}</strong>
                        </span>
                      </li>
                      <li class="list-inline-item g-mr-20">
                        <i
                          class="icon-symbol-female g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"
                          v-if="personDetails.gender =='Female' && personDetails.gender"
                        ></i>
                        <i
                          class="icon-symbol-male g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"
                          v-if="personDetails.gender =='Male' && personDetails.gender"
                        ></i>
                        <strong v-if="personDetails.gender">
                          <span class="e-nusx-8">
                            <small>სქესი:</small>
                          </span>
                          {{personDetails.gender }}
                        </strong>
                      </li>
                      <li class="list-inline-item g-mr-20" v-if="personDetails.aliases.length > 0">
                        <i class="fas fa-users g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                        <span class="e-nusx-8">
                          <small>სხვა ცნობილი სახელები:</small>
                        </span>
                        <span v-for="a in personDetails.aliases" :key="a.$index">
                          <strong>{{a.forename}} {{a.middlename}} {{a.surname}}; </strong>
                        </span>
                      </li>
                    </ul>
                    <!-- End User Info -->
                    <div class="card mb-2">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-book-open g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">საკონტაქტო ინფორმაცია</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-12" v-if="personDetails.telephoneNumber || personDetails.faxNumber || personDetails.email">
                            <ul class="list-inline g-font-weight-300">
                              <li class="list-inline-item g-mr-20 g-mb-10" v-if="personDetails.telephoneNumber">
                                <i class="fas fa-phone-square-alt g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                                <span class="e-nusx-8">
                                  <small>ტელეფონის ნომერი:</small>
                                </span>
                                <strong>{{personDetails.telephoneNumber?personDetails.telephoneNumber:' '}}</strong>
                              </li>
                              <li class="list-inline-item g-mr-20 g-mb-10" v-if="personDetails.faxNumber">
                                <i class="fas fa-phone-square g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"></i>
                                <span class="e-nusx-8">
                                  <small>ფაქსი:</small>
                                </span>
                                <strong>{{personDetails.faxNumber? personDetails.faxNumber:' '}}</strong>
                              </li>
                              <li class="list-inline-item g-mr-20 g-mb-10" v-if="personDetails.email">
                                <i
                                  class="far fa-envelope g-pos-rel g-top-1 g-color-gray-dark-v5 g-mr-5"
                                ></i>
                                <span class="e-nusx-8">
                                  <small>ელ-ფოსტა:</small>
                                </span>
                                <strong>{{personDetails.email?personDetails.email:' '}}</strong>
                              </li>
                            </ul>
                          </div>
                          <hr class="g-brd-gray-light-v4 g-my-20" />
                          <div class="col-12 pl-0 pr-0" v-if="personDetails.addresses.length > 0">
                            <div class="row">
                              <div
                                class="col-xl-6 col-sm-12 col-md-6 col-lg-6"
                                v-for="(ad, index) in personDetails.addresses"
                                :key="ad.$index"
                              >
                                <div class="card mb-3 e-no-box-shadow">
                                  <div class="card-header e-nusx-8">
                                    <strong>
                                      მისამართი #
                                      <span class="e-eng-font">{{index+1}}</span>
                                    </strong>
                                  </div>
                                  <div class="card-body">
                                    <p class="card-text" v-if="ad.address1 || ad.address2 || ad.address3 ||ad.address4">
                                      <span class="e-nusx-8">
                                        <small>მისამართი:</small>
                                      </span>
                                      <strong>
                                        {{ad.address1?ad.address1 + ',': ''}}
                                        {{ad.address2?ad.address2 + ',': ''}}
                                        {{ad.address3?ad.address3 + ',': ''}}
                                        {{ad.address4?ad.address4: ''}}
                                      </strong>
                                    </p>
                                    <p class="card-text" v-if="ad.city">
                                      <span class="e-nusx-8">
                                        <small>ქალაქი:</small>
                                      </span>
                                      <strong>{{ad.city?ad.city: ''}}</strong>
                                    </p>
                                    <p class="card-text" v-if="ad.country.name">
                                      <span class="e-nusx-8">
                                        <small>ქვეყანა:</small>
                                      </span>
                                      <strong>{{ad.country.name?ad.country.name: ''}}</strong>
                                    </p>
                                    <p class="card-text" v-if="ad.county">
                                      <span class="e-nusx-8">
                                        <small>რეგიონი:</small>
                                      </span>
                                      <strong>{{ad.county?ad.county: ''}}</strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <!-- სანქციები დასაწყისი -->
                    <div class="card mb-2" v-if="personDetails.sanctions.length > 0">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">სანქციები</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <ul class="row u-timeline-v2-wrap list-unstyled">
                          <li
                            class="col-md-12 g-brd-bottom g-brd-0--md g-brd-gray-light-v4 g-pb-30 g-pb-0--md g-mb-30 g-mb-0--md"
                            v-for="san in personDetails.sanctions"
                            :key="san.$index"
                          >
                            <div class="row">
                              <!-- Timeline Date -->
                              <div
                                class="col-md-3 align-self-center text-md-right g-pr-40--md g-mb-20 g-mb-0--md"
                              >
                                <h4 class="h5 g-font-weight-300 e-nusx-8">სანქციის სტატუსი</h4>
                                <h5
                                  class="h6 g-font-weight-300 mb-0 e-mtavr-17"
                                  :class="san.isCurrent?'badge badge-danger':'badge badge-purple'"
                                >{{san.isCurrent?'აქტიური':'გაუქმებული'}}</h5>
                              </div>
                              <!-- End Timeline Date -->

                              <!-- Timeline Content -->
                              <div
                                class="col-md-9 align-self-center g-orientation-left g-pl-40--md"
                              >
                                <!-- Timeline Dot -->
                                <div class="g-hidden-sm-down u-timeline-v2__icon g-top-35">
                                  <i
                                    class="d-block g-width-18 g-height-18 g-brd-around g-brd-4 g-brd-gray-light-v4 rounded-circle"
                                    :class="san.isCurrent?'bg-danger-dark':'bg-purple-dark'"
                                  ></i>
                                </div>
                                <!-- End Timeline Dot -->

                                <article class="g-pa-10--md mb-4 mt-4">
                                  <h3 class="h4 g-font-weight-300">
                                    <strong>{{san.sanctionType.description}}</strong>
                                  </h3>
                                </article>
                              </div>
                              <!-- End Timeline Content -->
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- სანქციები დასასრული -->
                    <!-- დამატებითი ინფორმაცია დასაწყისი -->
                    <div class="card mb-2">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">დამატებითი ინფორმაცია</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <div v-for="n in personDetails.notes" :key="n.$index">
                          <p class="card-text">
                            <span class="icon-arrow-right-circle"></span>
                            <span class="e-nusx-8" v-if="n.dataSource">
                              <small>ინფორმაციის წყარო:</small>
                            </span>
                            {{n.dataSource? n.dataSource.name + ";": ""}}
                            <span class="e-nusx-8">
                              <small>ინფორმაცია:</small>
                            </span>
                            {{n.text}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- დამატებითი ინფორმაცია დასასრული -->
                    <!-- პოლიტიკური თანამდებობები დასაწყისი -->
                    <div class="card mb-2" v-if="personDetails.politicalPositions.length > 0">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">პოლიტიკური თანამდებობები</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <ul class="row u-timeline-v2-wrap list-unstyled">
                          <li
                            class="col-md-12 g-brd-bottom g-brd-0--md g-brd-gray-light-v4 g-pb-30 g-pb-0--md g-mb-30 g-mb-0--md"
                            v-for="pol in personDetails.politicalPositions"
                            :key="pol.$index"
                          >
                            <div class="row">
                              <!-- Timeline Date -->
                              <div
                                class="col-md-3 align-self-center text-md-right g-pr-40--md g-mb-20 g-mb-0--md"
                              >
                                <h4 class="h5 g-font-weight-300 e-nusx-8">
                                  <small>თანამდებობას იკავებდა:</small>
                                </h4>
                                <h5 class="h6 g-font-weight-300 mb-0">
                                  <strong
                                    v-if="(pol.from && pol.to) || pol.from"
                                  >{{pol.from?pol.from:'დაუდგენელია'}} - {{pol.to?pol.to:'დღემდე'}}</strong>
                                </h5>
                              </div>
                              <!-- End Timeline Date -->

                              <!-- Timeline Content -->
                              <div
                                class="col-md-9 align-self-center g-orientation-left g-pl-40--md"
                              >
                                <!-- Timeline Dot -->
                                <div class="g-hidden-sm-down u-timeline-v2__icon g-top-35">
                                  <i
                                    class="d-block g-width-18 g-height-18 bg-purple-dark g-brd-around g-brd-4 g-brd-gray-light-v4 rounded-circle"
                                  ></i>
                                </div>
                                <!-- End Timeline Dot -->

                                <article class="g-pa-10--md">
                                  <h3 class="h4 g-font-weight-300">
                                    <span class="e-nusx-8">ქვეყანა:</span>
                                    <strong>{{pol.country? pol.country.name : ""}}</strong>
                                  </h3>
                                  <p class="mb-0">
                                    <span class="e-nusx-8">თანამდებობა:</span>
                                    {{pol.description}}
                                  </p>
                                </article>
                              </div>
                              <!-- End Timeline Content -->
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- პოლიტიკური თანამდებობები დასასრული -->
                    <!-- დაკავშირებული ბიზნესები დასაწყისი-->
                    <div class="card mb-2" v-if="personDetails.linkedBusinesses.length > 0">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">დაკავშირებული ბიზნესები</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table u-table--v1 mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th class="e-mtavr-17">ბიზნესის ნომერი</th>
                                <th class="e-mtavr-17">ბიზნესის სახელი</th>
                                <th class="e-mtavr-17">კავშირის განმარტება</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(lb, index) in personDetails.linkedBusinesses"
                                :key="lb.$index"
                              >
                                <th scope="row">{{index+1}}</th>
                                <td>{{lb.businessId}}</td>
                                <td>{{lb.businessName}}</td>
                                <td>{{lb.linkDescription}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- დაკავშირებული ბიზნესები დასასრული-->
                    <!-- დაკავშირებული პირები დასაწყისი -->
                    <div class="card mb-2" v-if="personDetails.linkedPersons.length > 0">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">დაკავშირებული პირები</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table u-table--v1 mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th class="e-mtavr-17">მონაცემთა ბაზაში ჩანაწერის ნომერი</th>
                                <th class="e-mtavr-17">სრული სახელი</th>
                                <th class="e-mtavr-17">კავშირის განმარტება</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(lp, index) in personDetails.linkedPersons"
                                :key="lp.$index"
                              >
                                <th scope="row">{{index+1}}</th>
                                <td class="text-center">{{lp.personId}}</td>
                                <td>{{lp.name}}</td>
                                <td>{{lp.association}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- დაკავშირებული პირები დასასრული -->
                    <!-- დოკუმენტები დასაწყისი -->
                    <div class="card mb-2" v-if="personDetails.articles.length > 0">
                      <div class="card-header e-bold">
                        <h5 class="mb-0 e-bold">
                          <i class="icon-graduation g-pos-rel g-top-1 g-mr-5"></i>
                          <span class="e-mtavr-17">დოკუმენტები</span>
                        </h5>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table u-table--v1 mb-0" style="max-width: 100%!important">
                            <thead>
                              <tr>
                                <th class="e-mtavr-17">დოკუმენტის თარიღი და კატეგორია</th>
                                <th class="e-mtavr-17">დოკუმენტი</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="a in personDetails.articles"
                                :key="a.$index"
                              >
                                <td>{{a.dateCollected}}<br><span v-for="cat in a.categories" :key="cat.$index">{{cat.name}}; </span></td>
                                <td>
                                  <p><span class="e-nusx-8">სათაური: </span><strong>{{a.snippet?a.snippet.title:""}}</strong></p>
                                  <p><span class="e-nusx-8">მოკლე შინაასი / ციტატა: </span><strong>{{a.snippet?a.snippet.summary:""}}</strong></p>
                                  <p v-if="a.snippet"><span class="e-nusx-8">საინტერესო ფრაზები: </span><strong  v-for="kw in a.snippet.keywordsMatched" :key="kw.$index">{{kw}}</strong></p>
                                  <p v-if="a.snippet"><span class="e-nusx-8">წყარო: </span><a :href="a.originalURL">{{a.originalURL}}</a></p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- დოკუმენტები დასასრული -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>
</template>

<script>
export default {
  props: ['personDetails', 'investigatingRequest'],
  Data () {
    return {
    }
  }
}
</script>

<style>

</style>
